import getUserAssetStatus, { STATUS_COMPLETED, STATUS_FAILED, STATUS_COMPLETED_ICON, STATUS_FAILED_ICON } from './getUserAssetStatus';
import { AUTOMATIC } from 'utils/asset/markAsDoneModes';
function getMarkAsDoneButtonProps(_ref) {
  var type = _ref.type,
    userContentStatus = _ref.userContentStatus,
    userScormAssetStatus = _ref.userScormAssetStatus,
    markAsDoneMode = _ref.markAsDoneMode;
  var _getUserAssetStatus = getUserAssetStatus({
      type: type,
      userContentStatus: userContentStatus,
      userScormAssetStatus: userScormAssetStatus
    }),
    status = _getUserAssetStatus.status,
    i18nLabelKey = _getUserAssetStatus.i18nLabelKey;
  var isTypeScorm = type === 'scorm';
  var isCompleted = status === STATUS_COMPLETED;
  var isFailed = status === STATUS_FAILED;
  var buttonLabel = 'actions_mark_done';
  if (isFailed || isCompleted) {
    buttonLabel = i18nLabelKey;
  }
  return {
    buttonTooltip: isTypeScorm || markAsDoneMode === AUTOMATIC ? 'asset_viewer_mark_done_automatic' : 'actions_mark_done',
    buttonLabel: buttonLabel,
    buttonIcon: isFailed ? STATUS_FAILED_ICON : STATUS_COMPLETED_ICON,
    isActive: isCompleted || isFailed,
    isDisabled: isTypeScorm
  };
}
export default getMarkAsDoneButtonProps;